import * as React from "react";
import { Context } from "./_context";
export const FlatFeeIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17.124 3.008a1 1 0 0 1 .707.436l3.674 5.497.075.136a1 1 0 0 1-.016.876l-.083.132-1.446 1.99A2 2 0 0 1 21.5 14v6a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h1v-1a3 3 0 0 1 3-3h1v2h-1a1 1 0 0 0-1 1v1h2.618l1.836-2.527L16.466 5H4v9h4v2H3a1 1 0 0 1-1-1V4l.005-.103A1 1 0 0 1 3 3h14l.124.008ZM12 20h7.5v-6H12v6Z", fill: "currentColor" }));
  return iconset[size];
};
FlatFeeIcon.iconId = "Pzp2W8";
